<template>
  <v-card elevation="1" :style="`max-width:${width}`">
    <v-card-title v-if="!hideSearch">
      <v-text-field
        v-model="search"
        id="table-search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      class="pt-2"
      :headers="myHeaders"
      :items="items"
      :item-key="itemKey"
      :search="search"
      :single-select="singleSelect"
      :loading-text="loadingText"
      :dense="dense"
      :no-data-text="noDataText"
      :page.sync="page"
      :items-per-page="limit"
      :custom-filter="customFilter"
      :show-select="showSelect"
      :loading="loading"
      @click:row="rowClickEvent"
      hide-default-footer
      :options.sync="optionsObj"
      v-model="selectedItems"
      :id="tableId"
      @pagination="updateFooter"
  >
    <template 
      v-for="field in headers" 
      class="ma-0 pa-0" 
      :slot="slotName(field)" 
      slot-scope="scope" 
      :style="`width: ${field.width} !important`">
      <slot class="ma-0 pa-0" :name="slotName(field)" v-bind="scope">{{scope.item[field.value]}}</slot>
    </template>

    <template v-slot:footer>
      <DataTableFooter :footerPagination="footerPagination" @updatePage="updatePage" :loading="loading" @FooterRefresh="refresh" />
    </template>
      <!-- eslint-disable-next-line -->
    <template v-slot:item.data-table-select="{ item, isSelected, select }" v-if="defaultCheckbox">
      <v-simple-checkbox
        :id="'check-'+parseInt(items.indexOf(item)+1)"
        :value="isSelected"
        @input="select($event)"
      ></v-simple-checkbox>
    </template>

  </v-data-table>
  </v-card>
</template>

<script>
import DataTableFooter from './DataTableFooter.vue'

export default {
  name: 'Table',
  components: {
    DataTableFooter,
  },
  props: {
    width:{default:"100%"},
    dense:{default:true},
    pagination: { default: null },
    value: { default: 1 },
    limit: { default: 15 },
    headers: { required: true },
    itemKey: {default: undefined},
    singleSelect: {default: false},
    showSelect: {default: false},
    items: { required: true },
    loading: { default: false },
    rowClickEvent: { type: Function, default: () => {} },
    loadingText: { default: "Loading items..."},
    noDataText: {default: "No items available"},
    selectedRows: {type:Array},
    hideSearch: {type:Boolean, default: false},
    customFilter: {default: ()=> {}},
    options: {required: false},
    tableId: {required: false, default: 'table-id'},
    defaultCheckbox: {required: false, default: true}
  },
  data() {
    return {
      search: '',
      selectedItems: [],
      idTimeout: null,
      footerPagination: {}
    }
  },
  watch: {
    selectedItems(newlySelectedRows) {
      this.$emit('update:selectedRows', newlySelectedRows)
    },
    page(val){
      this.$emit('update:page',val)
    },
    search:  {
      handler: function(){
        clearTimeout(this.idTimeout)
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    page: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    optionsObj: {
      get() {
        return this.options
      },
      set(val) {
        this.$emit('update:options', val)
      }
    },
    results () {
      if (this.pagination) return this.pagination.count
      return this.items.length
    },
    pages () {
      if (this.pagination) return this.pagination.pages
      return Math.ceil(this.results / this.limit)
    },
    myHeaders:{
      get:function(){let headers=[]
        headers = this.headers
        !this.headers.some(item => item.value==="data-table-select")&&this.showSelect?headers.unshift({align:"start", value:"data-table-select", width:'4% !important'}):''
        return headers.map(item => {
          item.value=='actions'?headers.length<6?item.width="15% !important":item.width="12% !important":''
          return item
        })
      }
    }
  },
  methods: {
    slotName (field) {
      return `item.${field.value}`
    },
    refresh () {
      this.page = 1
      this.$emit('refresh')
    },
    updateFooter(pag) {
      this.footerPagination = pag
      if (this.pagination){
        this.footerPagination.pageCount = this.pagination.pages
        this.footerPagination.itemsLength = this.pagination.count
        this.footerPagination.page = this.page

      }
    },
    updatePage(val) {
      this.page = val
    },
    clearSelected() {
      this.selectedItems = []
    }
  },
  created(){
    this.page = 1
  }
}
</script>
<style scoped>
.v-data-table >>> td{
  padding: 0 0 0 16px !important
}
.v-data-table >>> th{
  padding: 0 0 0 16px !important
}
</style>